module.exports = __webpack_public_path__ + "static/media/locationIcon.b8d924d4.svg";